import styled, { keyframes } from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

export const Container = styled.button<{ $isClickable: boolean }>`
  height: 56px;
  width: 100%;
  padding: 0 2rem 0 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  border-radius: 0;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'auto')};
  background: transparent;
`;

export const Text = styled.p<{
  brandFontKey: keyof typeof brandFont;
}>`
  font: ${({ brandFontKey }) => brandFont[brandFontKey]};
  color: ${({ theme }) => theme.token('text-default')};
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Loading = styled.span`
  display: block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(31, 31, 31, 0.1);
  border-radius: 50%;
  border-top-color: ${Styles.color.primary};
  animation: ${spin} 1s ease-in-out infinite;
`;
